import { updateFunnelCollection, FunnelName, FunnelCollectionName } from "../../firebase";

export const updateCheckout = ({ data, documentId, firebase }) =>
  updateFunnelCollection({
    data,
    documentId,
    firebase,
    funnelName: FunnelName.Cicl,
    name: FunnelCollectionName.Checkout
  });
